import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { client, urlFor, blogQueries } from '../sanityClient'
import './recent-blog-posts.css'

const RecentBlogPosts = () => {
  const [recentPosts, setRecentPosts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        setLoading(true)
        const posts = await client.fetch(blogQueries.getRecentPosts)
        setRecentPosts(posts)
        setError(null)
      } catch (err) {
        console.error('Error fetching recent blog posts:', err)
        setError('Failed to load recent posts.')
      } finally {
        setLoading(false)
      }
    }

    fetchRecentPosts()
  }, [])

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }

  if (loading) {
    return (
      <section className="recent-blog-posts-section">
        <div className="recent-blog-posts-container">
          <div className="recent-blog-posts-header">
            <h2>Latest Blog Posts</h2>
            <p>Loading latest insights...</p>
          </div>
          <div className="recent-blog-posts-loading">
            <div className="loading-spinner"></div>
          </div>
        </div>
      </section>
    )
  }

  if (error || recentPosts.length === 0) {
    return (
      <section className="recent-blog-posts-section">
        <div className="recent-blog-posts-container">
          <div className="recent-blog-posts-header">
            <h2>Latest Blog Posts</h2>
            <p>Coming soon - stay tuned for insights on SMS marketing and business growth!</p>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="recent-blog-posts-section" data-aos="fade-up">
      <div className="recent-blog-posts-container">
        <div className="recent-blog-posts-header">
          <h2>Latest Blog Posts</h2>
          <p>Stay updated with the latest insights on SMS marketing and business communication.</p>
        </div>
        
        <div className="recent-blog-posts-grid">
          {recentPosts.map((post, index) => (
            <article 
              key={post._id} 
              className="recent-blog-post-card" 
              data-aos="fade-up" 
              data-aos-delay={index * 100}
            >
              <Link to={`/blog/${post.slug.current}`} className="recent-blog-post-link">
                {post.mainImage && (
                  <div className="recent-blog-post-image">
                    <img 
                      src={urlFor(post.mainImage).width(350).height(200).url()} 
                      alt={post.title}
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="recent-blog-post-content">
                  <div className="recent-blog-post-meta">
                    <span className="recent-blog-post-date">
                      {formatDate(post.publishedAt)}
                    </span>
                  </div>
                  <h3 className="recent-blog-post-title">{post.title}</h3>
                  {post.excerpt && (
                    <p className="recent-blog-post-excerpt">{post.excerpt}</p>
                  )}
                  <div className="recent-blog-post-read-more">
                    Read More →
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
        
        <div className="recent-blog-posts-footer">
          <Link to="/blog" className="recent-blog-posts-view-all">
            View All Blog Posts
          </Link>
        </div>
      </div>
    </section>
  )
}

export default RecentBlogPosts 